<template>
  <div class="container-download">
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      style="width: 100%"
      class="list-table"
    >
      <el-table-column label="附件名称" prop="file_name">
        <template slot-scope="scope">
          <div
            class="green-69"
            style="cursor: pointer; margin-left: 13px"
            @click="toAttach(scope.row)"
          >
            {{ scope.row.file_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下载时间" prop="download_time" width="140">
      </el-table-column>
      <el-table-column label="所属文章" prop="doc.title"> </el-table-column>
      <el-table-column label="附件位置" prop="full_path">
        <template slot-scope="scope">
          <div class="path-wrap" v-if="!scope.row.show_full_path">
            <span>{{ scope.row.full_path[0] }}</span>
            <img
              class="icon"
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/path-arrow.png"
              @click="showFullPath(scope)"
              v-debounce="1000"
              style="cursor: pointer; margin-left: 6px"
            />
          </div>
          <div class="path-wrap" v-else>
            <span
              class="path"
              v-for="(item, index) in scope.row.full_path"
              :key="index"
              ><i class="el-icon-arrow-right arrow" v-show="index !== 0"></i
              ><span class="text">{{ item }}</span></span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import {
  getDocDownloadListApi,
  getDocPositionApi,
  getDocUuidApi,
} from "@/api/wow";
import { dateFormat } from "@/utils/timeFormat";
import eventBus from "@/utils/bus";
export default {
  props: ["visible"],

  name: "",
  data() {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  created() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  },
  methods: {
    getList(options) {
      let param = { ...options };
      getDocDownloadListApi(param).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.full_path = [item.root_catalog.name];
            item.show_full_path = false;
            item.download_time = item.download_time
              ? dateFormat("YYYY-mm-dd HH:MM", item.download_time * 1000)
              : "-";
          });
          this.tableData = res.data.list;
          this.page = res.data.page;
          this.total = res.data.total;
        }
      });
    },
    showFullPath(scope) {
      getDocPositionApi({
        version_id: scope.row.root_catalog.version_id,
        doc_id: scope.row.doc_id,
      }).then((res) => {
        this.tableData[scope.$index].full_path = res.data.position.map(
          (item) => {
            return item.name;
          }
        );
        this.tableData[scope.$index].show_full_path = true;
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    toAttach(row) {
      getDocUuidApi({
        root_doc_id: row.doc.root_doc_id,
      }).then((res) => {
        eventBus.$emit("material-library-aside-location", {
          catalog_uuid: res.data.catalog_uuid,
          attach_uuid: row.file_uuid,
          type: "attach",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container-download {
  margin: 30px 0;
  .table-location {
    .location-text {
      line-height: 14px;
    }
  }
  .success {
    background: rgba(69, 177, 59, 1) !important;
    border-color: rgba(69, 177, 59, 1) !important;
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.green-69 {
  color: rgba(69, 177, 59, 1);
}
.path-wrap {
  .icon {
    width: 12px;
  }
  .path {
    .arrow {
      margin: 0 5px;
      font-size: 12px;
      white-space: nowrap;
    }
    .text {
      white-space: nowrap;
    }
  }
}
/deep/.list-table {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  th {
    height: 46px;
    background-color: #f2f6fa !important;
  }
  td {
    .cell {
      font-size: 13px;
      div {
        font-size: 13px;
      }
    }
  }
  .el-table__header {
    tr {
      th:first-child {
        padding-left: 13px;
      }
    }
  }
}
</style>
